import StockListado from '../../../models/stock/stock_listado'
import { TABLA_EXISTENCIA_DIARIA, TABLA_EXISTENCIA_DIARIA_VARIEDAD } from '../../../config/tables'
import { COL_EXISTENCIA_DIARIA, COL_EXISTENCIA_DIARIA_VARIEDAD } from './listados/constantes'
import { toast } from 'react-toastify'
import moment from 'moment'
import Stock from '../../../models/stock/stock'
import { obtenerPesoPromedioCamion, updateParametroInteger } from '../../Camiones/actions'
import { obtenerCumplimientoCupos } from '../../Cupos/actions'

const stockListado = new StockListado()

export default function obtenerMercaderiaEnTerminal () {
  return (dispatch) => {
    stockListado.getMercaderiaEnTerminalTotal()
      .then((data) => {
        dispatch({ type: 'EXISTENCIA_DIARIA', data })
      })
      .catch((error) => {
        console.log(error)
      })
  }
}

export function obtenerExistenciaDiariaPorVariedad (fechaConsulta) {
  return (dispatch) => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_EXISTENCIA_DIARIA_VARIEDAD
    })

    const fecha = moment(fechaConsulta).format('YYYY-MM-DD')
    stockListado.getExistenciaDiariaVariedad(fecha)
      .then((data) => {
        const customToolbar = null
        dispatch({
          type: 'UPDATE_MUITABLE',
          newState: {
            columns: COL_EXISTENCIA_DIARIA_VARIEDAD,
            data: data,
            title: `Existencia diaria por variedad`,
            isLoading: false,
            fixed2Decimales: false,
            extraOptions: {
              customToolbar,
              print: false,
              pagination: false,
              tableBodyMaxHeight: '499px'
            }
          },
          id: TABLA_EXISTENCIA_DIARIA_VARIEDAD
        })
      })
      .catch((error) => {
        console.log(error)
        toast.error('Error al intentar obtener los datos')
      })
  }
}

export function obtenerExistenciaDiariaPorCereal (fechaConsulta) {
  return (dispatch) => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_EXISTENCIA_DIARIA
    })

    const fecha = moment(fechaConsulta).format('YYYY-MM-DD')
    stockListado.getExistenciaDiariaPorCereal(fecha)
      .then((data) => {
        const customToolbar = null
        dispatch({
          type: 'UPDATE_MUITABLE',
          newState: {
            columns: COL_EXISTENCIA_DIARIA,
            data: data,
            title: `Existencia diaria`,
            isLoading: false,
            fixed2Decimales: false,
            extraOptions: {
              customToolbar,
              print: false,
              pagination: false,
              tableBodyMaxHeight: '499px'
            }
          },
          id: TABLA_EXISTENCIA_DIARIA
        })
      })
      .catch((error) => {
        console.log(error)
        toast.error('Error al intentar obtener los datos')
      })
  }
}

// export function actualizarFecha (fecha) {
//   return (dispatch, getState) => dispatch({
//     type: 'ACTUALIZAR_FECHA_CONSULTA_STOCK',
//     fecha
//   })
// }

export function actualizarDetalles (detalle) {
  return (dispatch) => {
    dispatch({
      type: 'ACTUALIZAR_DETALLES',
      detalle: detalle
    })
  }
}

export function obtenerTotalStock () {
  return (dispatch) => {
    return Stock.getStockTotal()
      .then((data) => {
        console.log(data, 'data')
        dispatch({ type: 'RECEIVE_STOCK_TOTAL', data })
      })
      .catch((error) => {
        console.log(error)
      })
  }
}

export function obtenerParametroCamion () {
  return obtenerPesoPromedioCamion()
}

export function obtenerParametroCumplimiento () {
  return obtenerCumplimientoCupos()
}

export function updateParametroCamion (value) {
  return updateParametroInteger('NETORGDF', value)
}

export function updateParametroCumplimiento (value) {
  return (dispatch) => {
    dispatch(updateParametroInteger('CUMPLICU', value))
    dispatch({ type: 'RECEIVE_PROMEDIO_CUMPLIMIENTO', value })
  }
}

export function updateSimulacionExportador (newValue) {
  return (dispatch) => {
    dispatch({ type: 'UPDATE_SIMULACION_POR_EXPORTADOR', newValue })
  }
}
